module.exports = __webpack_public_path__ + "static/img/logo5.40ac17bd.png";